
import ParkHeader from "@/components/ParkHeader.vue";
import Utils from "@/components/Utils";
import { defineComponent, onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import CharaControl from "@/components/CharaControl.vue";
import isMobile from "ismobilejs";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import SwiperNavi from "@/components/SwiperNavi.vue";
import store from "@/store/index";
import CampaignTerms from "@/components/CampaignTerms.vue";

interface Slide {
  image: string;
  title: string;
  text: string;
  control?: string;
  arrow?: string;
  icon?: string;
  custom?: boolean;
}

export default defineComponent({
  components: {
    ParkHeader,
    CharaControl,
    Swiper,
    SwiperSlide,
    SwiperNavi,
    CampaignTerms,
  },

  setup(props, context) {
    context.emit("header", true);
    context.emit("contentShow", false);

    const route = useRoute();
    const main = ref<HTMLElement>();
    const arrow = ref<HTMLElement>();
    const router = useRouter();
    const queryStep = route.query.step;
    const step = ref<number>(queryStep ? 2 : 0);
    const isLast = ref<boolean>(false);
    const prevButton = ref();
    const nextButton = ref();
    const applyMessage = ref<string>("");
    const applyCheck = ref<boolean>(false);
    const canApply = ref<boolean>(true);
    const isCampaignStep = ref<boolean>(false);

    const pcData: Slide[] = [
      {
        image: "info_01.png",
        title: "ジョーズ・タウンの見どころ！",
        text: "ジョーズ・タウンは、一条の住まいや家づくりに役立つことを楽しく学べる場所です。",
      },
      {
        image: "info_02.png",
        title: "ジョーズ・タウンの見どころ！",
        text: "6つのパビリオンに加え、トロフィー集めやクイズ、かくれんぼなど、楽しい仕掛けがいっぱい！",
      },
      {
        image: "info_03.png",
        title: "ジョーズ・タウンの見どころ！",
        text: "さあ、好奇心の赴くままに、自由に巡ってみましょう！",
      },
      {
        image: "info_04.png",
        title: "操作方法",
        text: "まずはジョーズ・タウンでの移動方法をご説明します。",
      },
      {
        image: "info_05.png",
        title: "操作方法",
        text: "移動はキーボードの矢印キーを使います。",
      },
      {
        image: "info_06.png",
        title: "操作方法",
        text: "さらに、W・S・D・Aキーでも移動できます。",
      },
      {
        image: "info_07.png",
        title: "操作方法",
        text: "マウスを上下左右にドラッグすると、視点を操作できます。",
      },
      {
        image: "info_08.png",
        title: "操作方法",
        text: "スペースキーを押すとジャンプができます。いろんなところに登ってみてください。",
        control: "control-close",
      },
      {
        image: "info_09.png",
        title: "操作方法",
        text: "分からなくなったら画面左下の操作方法を見てください。",
        arrow: "control",
        control: "control-open",
      },
      {
        image: "info_10.png",
        title: "マップの表示（パビリオン選択）",
        text: "画面左上のボタンからジョーズ・タウンの地図が見られます。",
        arrow: "map",
        control: "map-open",
      },
      {
        image: "info_11.png",
        title: "マップの表示（パビリオン選択）",
        text: "パビリオンへの移動と、現在地の確認もできます。",
        arrow: "map",
      },
      {
        image: "info_12.png",
        title: "視点の切替",
        text: "となりにあるのは視点切替ボタンです。",
        arrow: "bird",
        control: "map-close",
      },
      {
        image: "info_13.png",
        title: "視点の切替「ノーマルビュー」",
        text: "アバターの目線で移動します。",
        arrow: "bird",
        icon: "info_13_icon.png",
      },
      {
        image: "info_14.png",
        title: "視点の切替「バードビュー」",
        text: "鳥のように上空から見下ろした目線で移動します。",
        arrow: "bird",
        icon: "info_14_icon.png",
      },
      {
        image: "info_15.png",
        title: "メニューの表示",
        text: "画面右上のボタンを押すとメニューが表示されます。",
        arrow: "menu",
        control: "menu-close",
      },
      {
        image: "info_15.png",
        title: "メニューの表示",
        text: "メニューの一覧から希望の項目を選んでください。",
        arrow: "menu-open",
        control: "menu-open",
      },
      {
        image: "info_17.png",
        title: "メニューの表示",
        text: "左上のBGMボタンで音楽のオンオフも行えます。",
        arrow: "bgm",
        control: "menu-open",
      },
      {
        image: "info_18.png",
        title: "パビリオンへの入場",
        text: "ジョーズ・タウンには６つのパビリオンがあります。入場方法をご説明します。",
        control: "menu-close",
      },
      {
        image: "info_19.png",
        title: "パビリオンへの入場",
        text: "まず、パビリオン前にある赤いエリアに入るか、エントランスに触れます。",
        arrow: "pavilion1",
      },
      {
        image: "info_20.png",
        title: "パビリオンへの入場",
        text: "案内が表示されたら、「入場する」を押すと入場できます。家づくりに役立つイイコトを学びましょう。",
      },
      {
        image: "info_21.png",
        title: "パビリオンへの入場",
        text: "＜ここでウラ技＞離れている場所でも、赤いダイヤをクリックするとワープして入場できます。",
        arrow: "pavilion3",
      },
      {
        image: "info_22.png",
        title: "クイズに挑戦！",
        text: "不思議なキャラクターに話しかけてクイズに挑戦。1キャラクターにつき、1日1問出題します。全問正解を目指してください！",
      },
      {
        image: "info_23.png",
        title: "ジョーくんを探せ！",
        text: "ジョーズ・タウンに隠れているジョーくんを見つけましょう！1日1回どこかに隠れています。",
      },
      {
        image: "info_25.png",
        title: "トロフィーを集めよう！",
        text: "パビリオンを巡ったり、クイズに正解すると、トロフィーを獲得できます。",
      },
      {
        image: "info_26.png",
        title: "一条マイスターになろう！",
        text: "トロフィーを集めると一条マイスターになれます。5個獲得でブロンズ、10個獲得でシルバー、20個獲得でゴールドマイスター！",
      },
      {
        image: "info_28.png",
        title: "一条マイスターになろう！",
        text: "獲得したトロフィーの個数とランクは画面右上で確認できます。",
        arrow: "trophy",
      },
      {
        image: "info_29.png",
        title: "一条マイスターになろう！",
        text: "ゴールドマイスターになるとアバターがパワーアップ！どうなるかはお楽しみ！",
      },
      {
        image: "info_30.png",
        title: "ジョーズ・タウンへ Go！",
        text: "さあ、ジョーズ・タウンを楽しもう！いってらっしゃい。",
      },
    ];

    const spData: Slide[] = [
      {
        image: "info_sp_01.png",
        title: "ジョーズ・タウンの見どころ！",
        text: "ジョーズ・タウンは、一条の住まいや家づくりに役立つことを楽しく学べる場所です。",
      },
      {
        image: "info_sp_02.png",
        title: "ジョーズ・タウンの見どころ！",
        text: "６つのパビリオンに加え、トロフィー集めやクイズ、かくれんぼなど、楽しい仕掛けがいっぱい！",
      },
      {
        image: "info_sp_03.png",
        title: "ジョーズ・タウンの見どころ！",
        text: "さあ、好奇心の赴くままに、自由に巡ってみましょう！",
      },
      {
        image: "info_sp_04.png",
        title: "操作方法",
        text: "まずはジョーズ・タウンでの移動方法をご説明します。",
      },
      {
        image: "info_sp_05.png",
        title: "操作方法",
        text: "移動は左下のコントローラーを行きたい方向にスワイプすると進みます。",
        arrow: "joystick",
      },
      {
        image: "info_sp_06.png",
        title: "操作方法",
        text: "右下のJUMPボタンを押すとジャンプができます。いろんなところに登ってみてください。",
        arrow: "jump",
      },
      {
        image: "info_sp_07.png",
        title: "操作方法",
        text: "画面を上下左右にスワイプすると、視点を操作できます。",
      },
      {
        image: "info_sp_08.png",
        title: "マップの表示（パビリオン選択）",
        text: "画面左上のボタンからジョーズ・タウンの地図が見られます。",
        arrow: "map",
      },
      {
        image: "info_sp_09.png",
        title: "マップの表示（パビリオン選択）",
        text: "パビリオンへの移動と、現在地の確認もできます。",
        arrow: "map",
      },
      {
        image: "info_sp_10.png",
        title: "視点の切替",
        text: "となりにあるのは視点切替ボタンです。",
        arrow: "bird",
      },
      {
        image: "info_sp_11.png",
        title: "視点の切替「ノーマルビュー」",
        text: "アバターの目線で移動します。",
        arrow: "bird",
        icon: "info_13_icon.png",
      },
      {
        image: "info_sp_12.png",
        title: "視点の切替「バードビュー」",
        text: "鳥のように上空から見下ろした目線で移動します。",
        arrow: "bird",
        icon: "info_14_icon.png",
      },
      {
        image: "info_sp_13.png",
        title: "メニューの表示",
        text: "画面右上のボタンを押すとメニューが表示されます。",
        arrow: "menu",
      },
      {
        image: "info_sp_14.png",
        title: "メニューの表示",
        text: "メニューの一覧から希望の項目を選んでください。",
        arrow: "menu",
      },
      {
        image: "info_sp_15.png",
        title: "メニューの表示",
        text: "メニュー画面の左上のBGMボタンで音楽のオンオフも行えます。",
        arrow: "menu",
      },
      {
        image: "info_sp_16.png",
        title: "パビリオンへの入場",
        text: "ジョーズ・タウンには６つのパビリオンがあります。入場方法をご説明します。",
      },
      {
        image: "info_sp_17.png",
        title: "パビリオンへの入場",
        text: "まず、パビリオン前にある赤いエリアに入るか、エントランスに触れます。",
        arrow: "pavilion1",
      },
      {
        image: "info_sp_18.png",
        title: "パビリオンへの入場",
        text: "案内が表示されたら、「入場する」を押すと入場できます。家づくりに役立つイイコトを学びましょう。",
      },
      {
        image: "info_sp_19.png",
        title: "パビリオンへの入場",
        text: "＜ここでウラ技＞離れている場所でも、赤いダイヤをクリックするとワープして入場できます。",
        arrow: "pavilion3",
      },
      {
        image: "info_sp_20.png",
        title: "クイズに挑戦！",
        text: "不思議なキャラクターたちに話しかけるとクイズに挑戦できます。1キャラクターにつき、1日1問出題します。全問正解を目指しましょう！",
      },
      {
        image: "info_sp_22.png",
        title: "ジョーくんを探せ！",
        text: "ジョーズ・タウンに隠れているジョーくんを見つけましょう！1日1回どこかに隠れています。",
      },
      {
        image: "info_sp_23.png",
        title: "トロフィーを集めよう！",
        text: "パビリオンを巡ったり、クイズに正解すると、トロフィーを獲得できます。",
      },
      {
        image: "info_sp_24.png",
        title: "一条マイスターになろう！",
        text: "トロフィーを集めると一条マイスターになれます。5個獲得でブロンズ、10個獲得でシルバー、20個獲得でゴールドマイスター！",
      },
      {
        image: "info_sp_25.png",
        title: "一条マイスターになろう！",
        text: "獲得したトロフィーの個数とランクは画面右上で確認できます。",
        arrow: "trophy",
      },
      {
        image: "info_sp_26.png",
        title: "一条マイスターになろう！",
        text: "ゴールドマイスターになるとアバターがパワーアップ！どうなるかはお楽しみ！",
      },
      {
        image: "info_sp_27.png",
        title: "ジョーズ・タウンへ Go！",
        text: "さあ、ジョーズ・タウンを楽しもう！いってらっしゃい。",
      },
    ];

    const mobile =
      isMobile(window.navigator).phone || isMobile(window.navigator).tablet;

    const contents = mobile ? spData : pcData;

    const menuComponent = ref<any>();
    const controlComponent = ref<any>();

    const prev = (value: number) => {
      step.value = value;
      isLast.value = false;
      allowControl();
    };

    const next = (value: number) => {
      step.value = value;
      if (step.value + 1 >= contents.length) isLast.value = true;
      allowControl();
    };

    const onSlideChange = (value: any) => {
      step.value = value.activeIndex;
      if (step.value + 1 >= contents.length) isLast.value = true;
      else isLast.value = false;
      allowControl();
    };

    const allowControl = () => {
      if (contents[step.value].control === "control-open") {
        controlComponent.value?.open();
      } else if (
        contents[step.value].control === "control-close" ||
        contents[step.value].control === "map-open"
      ) {
        controlComponent.value?.close();
      }

      isCampaignStep.value =
        contents[step.value].title ===
        "抽選でアマゾンギフト券が当たるチャンス！";

      // if (contents[step.value].control === "menu-open") {
      //   if (!mobile) menuComponent.value?.openMenu();
      // } else if (contents[step.value].control === "menu-close") {
      //   if (!mobile) menuComponent.value?.closeMenu();
      // }
    };

    const enter = () => {
      step.value = 0;
      router.push("/park");
    };

    const iPhone = isMobile(window.navigator).apple.phone;
    let resizeFlag = false;
    const resize = () => {
      let height = Utils.contentHeight("px");
      if (resizeFlag && iPhone) {
        height = "calc(100vh - 50px)";
        resizeFlag = false;
      }

      if (main.value) main.value.style.height = height;

      if (window.innerHeight !== document.documentElement.clientHeight)
        resizeFlag = true;
    };

    const scroll = () => {
      if (main.value) main.value.style.height = Utils.contentHeight("px");
    };

    const getCampaign = (campaign: Campaign): Campaign | undefined => {
      return store.state.campaign.find(
        (v: Campaign) =>
          v.id === campaign.id &&
          v.startDateTime === campaign.startDateTime &&
          v.endDateTime === campaign.endDateTime
      );
    };

    const apply = async () => {
      const campaign: Campaign = store.getters.getNewMemberCampaign;
      if (!campaign) return;

      if (!applyCheck.value) {
        applyMessage.value = "同意してください";
        return;
      }

      let body = new FormData();
      body.append("id", campaign.id);

      const success = await Utils.sendCampaign(body);
      if (success) {
        const c = getCampaign(campaign);
        if (c) c.isApply = true;

        pcData[pcData.length - 1].text =
          "応募が完了しました。さあ、ジョーズ・タウンを楽しもう！いってらっしゃい。";
        store.commit("setPostedCampaign", true);
        nextButton.value.next();
        canApply.value = false;
      } else {
        applyMessage.value = "応募に失敗しました";
      }
    };

    onMounted(async () => {
      if (step.value === 0) main.value?.classList.add("tutorial");
      resize();
      window.addEventListener("resize", () => resize());
      if (iPhone) window.addEventListener("scroll", () => scroll());

      window.addEventListener("keydown", (event) => {
        if (route.path !== "/information") return;
        if (event.code === "ArrowLeft" && prevButton.value) {
          prevButton.value.prev();
        }
        if (
          (event.code === "Enter" || event.code === "ArrowRight") &&
          nextButton.value
        ) {
          nextButton.value.next();
        }
      });

      const campaign: Campaign = store.getters.getNewMemberCampaign;
      if (campaign) {
        const slide1 = {
          image: "info_new_camp.png",
          title: "抽選でアマゾンギフト券が当たるチャンス！",
          text: "新規会員様の初回ログイン限定で抽選に参加できます。<br />皆さまぜひご応募ください！",
        };
        const slide2 = {
          image: "info_00.png",
          title: "抽選でアマゾンギフト券が当たるチャンス！",
          text: "",
          custom: true,
        };

        pcData.splice(pcData.length - 1, 0, slide1, slide2);
        spData.splice(spData.length - 1, 0, slide1, slide2);
      }
    });

    return {
      mobile,
      main,
      arrow,
      step,
      contents,
      isLast,
      prevButton,
      nextButton,
      prev,
      next,
      enter,
      menuComponent,
      controlComponent,
      onSlideChange,
      applyMessage,
      applyCheck,
      canApply,
      apply,
      isCampaignStep,
    };
  },
});
